// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { Box } from '@teamnine/pcj-ui-v2'
import styled from 'styled-components'

import { computeMaxContentWidth } from '@/utils/helpers'

const DEFAULT_MAX_CONTENT_WIDTH = computeMaxContentWidth()

export const Wrapper = styled(Box).attrs<{ p?: string }>((props) => ({
  p: props.p ?? '16px 24px',
  mb: 16,
}))<{ p?: string; maxWidth?: number; borderRadius?: number }>`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ borderRadius }) => borderRadius ?? 6}px;
  max-width: ${({ maxWidth }) => maxWidth ?? 1500}px;
`

export const Content = styled.div<{ maxWidth?: number }>`
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth ?? DEFAULT_MAX_CONTENT_WIDTH}px;
  margin: 0 auto;
`
